export const getTS = () => {
  let date = new Date();
  let ts = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().slice(0, 19).replace('T', ' ');
  return ts;
};
